export default "__VITE_ASSET__CM7NA$tl__"